/** Money received outside the web store; "card" was charged outside it (terminal or link). */
export type PaymentMethod = "cash" | "transfer" | "card";

export const paymentMethodLabel = (method?: string) => (method === "cash" ? "efectivo" : method === "card" ? "tarjeta" : "transferencia");
